import { render, staticRenderFns } from "./AppPhotoEditor.vue?vue&type=template&id=6970cf74&"
import script from "./AppPhotoEditor.vue?vue&type=script&lang=js&"
export * from "./AppPhotoEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports